<template>
  <div class="thousand_layout">
    <div class="chp_box">
      <div class="chp_index">
        <div class="chp_index_box">
          <div>{{ $t('base.balanceNow') }}</div>
          <div class="chp_num">{{userInfo.SumMoney}}</div>
          <div class="chp_change">
            <div>
              <router-link v-if="userInfo.VerifyStatus==2" class="chp_btn" :to="{path:'/pay/chp'}">{{ $t('title.charge') }}</router-link>
              <span v-if="noNew" class="chp_btn" @click="isRefund=true">{{ $t('base.Refund') }}</span>
            </div>
            <div class="What_c">
              <span></span>
              <router-link :to="{path:'/terms/privacy?type=3'}">{{ $t('symbol.whatCHP') }}</router-link>
            </div>
          </div>
        </div>
      </div>
      <template v-if="noNew">
        <el-dialog title="Enter refund info" :visible.sync="isRefund" custom-class="dialogBox" :lock-scroll="false">
          <div>
            <el-alert title="Your account has a record of violations, CHP cannot be refunded at this time. For assistance, please contact customer service at: customer@cardhobbysupport.com" type="error" show-icon :closable="false"></el-alert>
            <div class="refundDialogBox">
              <div class="Refundable">
                <div class="refundableCHP">
                  <div class="chp">{{$t('base.Refundable')}}:<span>1190</span></div>
                  <div class="text_gray">{{$t('base.NonRefundable')}}:1100 This CHP is a complimentary credit and is non-refundable.</div>
                </div>
              </div>
              <el-form>
                <el-form-item>
                <div>CHP</div>
                  <el-input v-model="refundForm.chp" size="medium" placeholder="Please enter the chp you want to return"></el-input>
                </el-form-item>
                <el-form-item>
                <div>PayPal</div>
                  <el-input v-model="refundForm.paypal" size="medium"></el-input>
                </el-form-item>
              </el-form>
              <div class="text_gray small_text">Please provide your PayPal account information (used only when CHP refunds cannot be issued to the original payment method).</div>
              <div class="alert_divider"></div>
              <div class="text_gray small_text">Refund processing may take up to 14 business days.</div>
              
              <div slot="footer" class="dialog-footer" style="text-align: right;margin-top: 60px;">
                <el-button  @click="isRefund=false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" >{{ $t('base.Submit') }}</el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </template>
      <div class="chp_list_box" v-if="list!=''">
        <h4 class="chp_h4">{{ $t('base.chpHistory') }}</h4>
        <div v-if="noNew">
          <div class="chp_tab">
            <div :class="{'active':(chpTab==0)}" @click="chpTab=0">{{$t('base.chpHistory')}}</div>
            <div :class="{'active':(chpTab==1)}" @click="chpTab=1">Refund History</div>
          </div>
          <div class="refund_tab">
            <template v-if="chpTab==1">
              <div :class="{'active':(refundType==0)}" @click="refundType=0">Pending</div>
              <div :class="{'active':(refundType==1)}" @click="refundType=1">{{$t('base.completed')}}</div>
            </template>
          </div>
        </div>
        <template v-if="chpTab==0">
          <ul class="chp_list">
            <li class=" chp_gary">
              <div>{{ $t('base.title') }}</div>
              <div>{{ $t('base.type') }}</div>
              <div class="text_right">{{ $t('base.amount') }}</div>
              <div class="text_right">{{ $t('base.balance') }}</div>
              <div class="tetx_time">{{ $t('base.createTime') }}</div>
            </li>
            <li v-for='(item,index) in list' :key="index">
              <div class="line_txt1">{{item.Describe?item.Describe:''}}</div>
              <div>{{item.ConsumptionType!=2?$t('base.deduct'):$t('base.increase')}}</div>
              <div class="text_right" :class="item.ConsumptionType!=2?'text_red':'text_greed'">{{item.ConsumptionType!=2?'':'+'}}{{item.Money}}</div>
              <div class="text_right">{{item.SumMoney}}</div>
              <div class="tetx_time">{{item.CreateDate|setTime}}</div>
            </li>
          </ul>
        </template>
        <template v-if="noNew&&chpTab==1">
          <ul class="chp_list chp_refund">
            <li class=" chp_gary">
              <div>PayPal</div>
              <div>CHP</div>
              <div>{{$t('base.RefundRequestDate')}}</div>
              <div>{{$t('base.RefundProcessedDate')}}</div>
              <div class="text_right">{{$t('base.RefundDocumentation')}}</div>
            </li>
            <li v-for='(item,index) in list' :key="index">
              <div class="line_txt1">123123123131</div>
              <div class="text_greed">{{item.Money}}</div>
              <div>{{item.CreateDate|setTime}}</div>
              <div>{{item.CreateDate|setTime}}</div>
              <div class="text_right">To be uploaded</div>
            </li>
          </ul>
        </template>
      </div>
    </div>
    <!-- <list-pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' /> -->
  </div>
</template>
<script>
import { getInfo,getTime,getUser,setInfo } from "@/api/public";
import ListPagination from '@/components/listpagination'
export default {
  name: 'chp',
  components: { ListPagination },
  data() {
    return {
      userInfo:'',
      ps: 60, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      list:'',
      chpTab:0,//0:chpHistory,1:RefundHistory
      refundType:0,//0:Pending,1:Completed

      refundForm:{
        chp:'',
        paypal:''
      },
      isRefund:false,
      noNew:false
    }
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    }
  },
  watch: {
    'chpTab': {
      handler(val) {
        if(val==0){
          this.Consumption()
        }
        if(val==1){
          this.refundList()
        }
        //this.getNationIcons()
      }
    },
    'refundType':{
      handler(val) {
        if(this.chpTab==0) return
        this.refundList()
        //this.getNationIcons()
      }
    }
  },
  created() {
    this.userInfo=getInfo()
    this.Consumption()
    this.getUserDetail()
  },
  mounted() {},
  methods: {
    // 获取用户详情
    /**
     * 获取用户详细信息
     * 通过接口请求获取用户的积分和总金额等信息
     * @method getUserDetail
     * @description 调用 GetUserDetail 接口获取用户详情，并更新本地用户信息
     * @returns {Promise} 返回请求结果的 Promise
     */
    getUserDetail() {
      let that = this;
      let data={'memberid':that.userInfo.MappingUserId,'token':that.userInfo.ChineseToken,'operator_id':that.userInfo.MappingUserId}
      that.$get(this.$interface.GetUserDetail,data).then(res=>{
        if(res.result!=0){
          let data=res.data;
          that.userInfo.PointCount=data.PointCount;
          that.userInfo.SumMoney=data.SumMoney;
          setInfo('PointCount', data.PointCount)
          setInfo('SumMoney', data.SumMoney)
         // getUser(that.userInfo,0)
          // window.localStorage.setItem("cardUser", JSON.stringify(that.userInfo))
        }
      })
    },
    // 获取消费明细
    /**
     * 获取用户消费记录
     * @description 通过用户ID和token调用接口获取消费记录列表
     * @method Consumption
     * @returns {Promise} 返回消费记录数据列表
     * @property {Object} data - 请求参数
     * @property {String} data.memberid - 会员ID
     * @property {String} data.operator_id - 操作员ID
     * @property {String} data.token - 中文token
     * @property {Number} data.pageindex - 页码
     * @property {String} data.begindate - 开始日期
     * @property {String} data.enddate - 结束日期
     * @property {String} data.ConsumptionType - 消费类型
     */
    Consumption() {
      let that = this
      that.refundType=0
      let data={memberid:that.userInfo.MappingUserId,operator_id:that.userInfo.MappingUserId,token:that.userInfo.ChineseToken,pageindex:1,begindate:'',enddate:'',ConsumptionType:''}
      this.$get(this.$interface.Consumption,data).then(res=>{
        if(res.result!=0){
          that.list=res.data
        }
        //console.log(res)
      })
    },
    refundList(){
      const that=this;
      console.log(1231231231)
    },
    // 
    pageSize(val) {
      this.ps = val
      //this.getDetailList();
    },
    // 页码
    pageIndex(val) {
      this.pi = val
      //this.getDetailList();
    },
  }
}

</script>
<style scoped>
.thousand_layout{
  width: auto;
}
.What_c{
  display: flex;
}
.What_c span{
  width: 16px;
  height: 16px;
  background: url(../../../static/images/icon_doubt.svg) no-repeat;
  margin: 0 4px 0 0;
}
.chp_box {
  padding: 20px 0;
}

.chp_index {
  height: 177px;
  min-width: 320px;
  display: inline-block;
  background: linear-gradient(to bottom right, RGBA(139, 154, 223, 1), RGBA(96, 110, 175, 1));
  border-radius: 5px;
  overflow: hidden;
}

.chp_index_box {
  background: url(../../../static/images/Frame.svg) right bottom no-repeat;
  width: 100%;
  height: 100%;
  color: #fff;
  padding: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
}

.chp_index_box:before {
  content: "";
  background: url(../../../static/images/icon/icon_CHP.svg) no-repeat;
  width: 40px;
  height: 40px;
  top: 16px;
  right: 16px;
  position: absolute;
}

.chp_num {
  font-size: 48px;
  font-weight: bold;
}

.chp_change {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.chp_change a {
  color: #fff;
  font-size: 14px;
}

.chp_btn {
  min-width: 46px;
  padding: 10px 20px;
  border: 1px solid #fff;
  border-radius: 4px;
  display: inline-block;
  line-height: 1;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer;
}

.chp_list_box {
  overflow: hidden;
}

.chp_h4 {
  font-size: 24px;
  margin-top: 40px;
  margin-bottom: 20px
}



.chp_list>li{
  display: grid;
  grid-template-columns: 36% 10% 10% 10% auto;
  border-bottom: 1px solid #e0e0e0;
  gap: 2%;
}
.chp_list>li>div{
  margin:12px;

}
.text_right{
  text-align: right;
}

.chp_gary{
  background-color: #f7f7f7;
}
.chp_list .tetx_time{
  padding-left: 52px;
}
.chp_refund>li{
  grid-template-columns: 23% 11% 19% 19% auto;
  align-items: center;
}

.chp_tab{
  border-bottom: 1px solid #C8C8C8;
  display: flex;
}
.chp_tab>div{
  border: 1px solid #C8C8C8;
  border-bottom: none;
  padding: 10px 20px;
  line-height: 1.5;
  font-size: 16px;
  cursor: pointer;
}
.chp_tab .active{
  color: #fff;
  background-color: #5F6DAE;
}
.refund_tab{
  margin: 18px auto 10px;
  display: flex;
}
.refund_tab div{
  padding: 10px 12px;
  font-size: 14px;
  color: #a0a0a0;
  background-color: #f7f7f7;
  border:1px solid #f7f7f7;
  border-radius: 4px;
  cursor: pointer;
}
.refund_tab div.active{
  border-color: #5F6DAE;
  color: #5F6DAE;
  background-color: #fff;
}
.refund_tab div+div{
  margin-left: 10px;
}
.refundDialogBox{
  margin: 0 auto;
  width: 92%
}
.Refundable{
  display: flex;
  margin: 12px auto;
  align-items: center;
}
.Refundable::before{
  content: '';
  background: url(../../../static/images/icon/icon_CHP.svg) no-repeat;
  width: 40px;
  height: 40px;
  display: block;
  margin-right: 24px;
}
.refundableCHP{
  flex: 1;
  line-height: 1.5;
}
.refundableCHP .chp{
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
}
.refundableCHP .chp span{
  font-size: 24px;
  margin-left: 4px;
}
.alert_divider{
  margin: 14px 0;
  border-top: 1px solid #e0e0e0;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/chp.vue